export default "__VITE_ASSET__CAQlQhtN__"